import React from "react";
import scrollTo from 'gatsby-plugin-smoothscroll';

export default function ServiceLandingStickySubmenu() {
    return (
        <div className="sticky-submenu">
            <div className="sticky-submenu-wrapper">
                <div className="container">
                    <div className="sticky-submenu-link">
                        <div onClick={() => scrollTo('#strategy')} id="service-strategy">Strategy</div>
                        <div onClick={() => scrollTo('#experience')} id="service-experience">Experiences</div>
                        <div onClick={() => scrollTo('#software')} id="service-software">Engineering</div>
                        <div onClick={() => scrollTo('#analytics')} id="service-analytics">Analytics</div>
                        <div onClick={() => scrollTo('#transformation')} id="service-transformation">Transformation</div>
                        <div onClick={() => scrollTo('#contact')} id="service-contact">Contact</div>
                    </div>
                </div>
            </div>
        </div>
    );
}